var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdobeCampaignLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Brush",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 97.71,
    cy: 81.62,
    r: 143.79,
    gradientTransform: "translate(-10.91 -10.93) scale(1.09 1.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1a1d05"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1 copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 235,
    fill: "url(#radial-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75,117A103.25,103.25,0,1,0,120,13.75,103.25,103.25,0,0,0,16.75,117Zm10.65,0A92.61,92.61,0,1,1,120,209.72,92.66,92.66,0,0,1,27.39,117Z",
    fill: "#d4f10d",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.94,133.91a16.22,16.22,0,0,1-7.94-2.07V141a24.69,24.69,0,0,0,7.94,1.31c13.64,0,25.5-10.08,25.5-24.79V50.85A71.88,71.88,0,0,0,137,47.9v69.64C137,127.7,128.95,133.91,119.94,133.91Zm.2-32.67a13.94,13.94,0,0,1,7.36,2.1V94.18A24.53,24.53,0,0,0,95,117.6v66.19a72.58,72.58,0,0,0,8.5,2.53V117.55A16.62,16.62,0,0,1,120.14,101.24ZM155,117.41c.13,22.25-16.25,34.85-35.05,34.85a34.26,34.26,0,0,1-7.94-1.18v3.41a37.76,37.76,0,0,0,7.94.85c20.83,0,38.18-15,38.06-37.77,0-.47,0-60.61,0-60.61-1.2-.77-1.8-1.6-3-2.3ZM120,82.94a23.85,23.85,0,0,1,7.51.81V80.67a37.86,37.86,0,0,0-8-.86c-20.82,0-37,15.64-37,36.46v61.27c1.2.75,1.72,1.41,3,2.09V117.55C85.51,98.76,99.84,83,120,82.94Zm47.47,34.57c.39,27.85-20.09,47.16-47.51,47.16a46.82,46.82,0,0,1-7.94-.81v3.43a50.14,50.14,0,0,0,7.94.63c27.77,0,50.83-19.2,50.56-50.34,0-.31,0-50.45,0-50.45-1.19-1.2-1.77-2.25-3-3.36Zm-97.4,50c1.18,1.17,1.68,2.35,2.94,3.44v-53.8c.13-28.47,19.2-46.39,44.94-46.39a53.69,53.69,0,0,1,8.56.69V67.88a50.6,50.6,0,0,0-8-.64C90.75,67.24,70,86.9,70,117.19Z",
    fill: "#f8ffcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeCampaignLogo);
export default __webpack_public_path__ + "static/media/adobe-campaign-logo.a6d8d979da4a5f684856113add8119d9.svg";
export { ForwardRef as ReactComponent };